// Import all plugins
import * as bootstrap from 'bootstrap';